// Реестр эндпоинтов этапа П (прототип, stages §1). Новое — добавлять сюда же, тест проверит фикстуры и уникальность.
import * as auth from './auth.js';
import * as battles from './battles.js';
import * as chat from './chat.js';
import * as support from './support.js';
import * as analytics from './analytics.js';
import * as coops from './coops.js';
import * as garage from './garage.js';
import * as inventory from './inventory.js';
import * as player from './player.js';
import * as quests from './quests.js';
import * as shop from './shop.js';
import * as social from './social.js';
import * as system from './system.js';

export * from './auth.js';
export * from './battles.js';
export * from './chat.js';
export * from './coops.js';
export * from './garage.js';
export * from './inventory.js';
export * from './models.js';
export * from './player.js';
export * from './quests.js';
export * from './shop.js';
export * from './social.js';
export * from './support.js';
export * from './analytics.js';
export * from './system.js';

export const api = {
  // §2 вход
  authTelegram: auth.authTelegram,
  authRefresh: auth.authRefresh,
  authLogout: auth.authLogout,
  // §3 профиль, кошелёк, обучение
  getBootstrap: player.getBootstrap,
  updateMe: player.updateMe,
  getNotifications: player.getNotifications,
  putNotifications: player.putNotifications,
  deleteAccount: player.deleteAccount,
  cancelAccountDelete: player.cancelAccountDelete,
  requestExport: player.requestExport,
  getExport: player.getExport,
  downloadExport: player.downloadExport,
  getMe: player.getMe,
  spendStats: player.spendStats,
  getWallet: player.getWallet,
  resetStats: player.resetStats,
  buyThermos: player.buyThermos,
  acceptConsent: player.acceptConsent,
  getLedger: player.getLedger,
  tutorialStep: player.tutorialStep,
  tutorialSkip: player.tutorialSkip,
  // §4 инвентарь
  getInventory: inventory.getInventory,
  equip: inventory.equip,
  unequip: inventory.unequip,
  dismantle: inventory.dismantle,
  lockItem: inventory.lockItem,
  upgradeItem: inventory.upgradeItem,
  sellItems: inventory.sellItems,
  getSales: inventory.getSales,
  buybackItem: inventory.buybackItem,
  transferPreview: inventory.transferPreview,
  transferItem: inventory.transferItem,
  getS8Tokens: inventory.getS8Tokens,
  exchangeS8: inventory.exchangeS8,
  openBoxes: inventory.openBoxes,
  getBoxOdds: inventory.getBoxOdds,
  // §5 гараж, машина, выезды; §3 публичный профиль
  getGarage: garage.getGarage,
  upgradeZone: garage.upgradeZone,
  speedupZone: garage.speedupZone,
  cancelZone: garage.cancelZone,
  getCar: garage.getCar,
  upgradeNode: garage.upgradeNode,
  patchNode: garage.patchNode,
  patchAll: garage.patchAll,
  getTrips: garage.getTrips,
  startTrip: garage.startTrip,
  speedupTrip: garage.speedupTrip,
  claimTrip: garage.claimTrip,
  getPlayer: garage.getPlayer,
  visitGarage: garage.visitGarage,
  // §3, §15 социальное (Р-59)
  respectPlayer: social.respectPlayer,
  getFriends: social.getFriends,
  addFriend: social.addFriend,
  acceptFriend: social.acceptFriend,
  removeFriend: social.removeFriend,
  reportPlayer: social.reportPlayer,
  getReferrals: social.getReferrals,
  prepareShare: social.prepareShare,
  createSupportTicket: support.createSupportTicket,
  getSupportTickets: support.getSupportTickets,
  createAppeal: support.createAppeal,
  analyticsBatch: analytics.analyticsBatch,
  // §8 чат, §9 задания и почта (пачка 5, Р-68)
  getChat: chat.getChat,
  postChat: chat.postChat,
  deleteChat: chat.deleteChat,
  reportChat: chat.reportChat,
  muteInChat: chat.muteInChat,
  getQuests: quests.getQuests,
  claimQuest: quests.claimQuest,
  getAchievements: quests.getAchievements,
  claimAchievement: quests.claimAchievement,
  claimDailyBox: quests.claimDailyBox,
  getMail: quests.getMail,
  claimMail: quests.claimMail,
  setTgGroup: coops.setTgGroup,
  deleteTgGroup: coops.deleteTgGroup,
  // §7 кооперативы; §6 инстансы общих режимов
  listCoops: coops.listCoops,
  createCoop: coops.createCoop,
  getCoop: coops.getCoop,
  joinCoop: coops.joinCoop,
  decideRequest: coops.decideRequest,
  leaveCoop: coops.leaveCoop,
  dissolveCoop: coops.dissolveCoop,
  cancelDissolve: coops.cancelDissolve,
  voteDissolve: coops.voteDissolve,
  inviteToCoop: coops.inviteToCoop,
  getMyCoopInvites: coops.getMyCoopInvites,
  decideInvite: coops.decideInvite,
  updateCoop: coops.updateCoop,
  getMyCoopRequests: coops.getMyCoopRequests,
  withdrawCoopRequest: coops.withdrawCoopRequest,
  setCoopRole: coops.setCoopRole,
  kickMember: coops.kickMember,
  cancelKick: coops.cancelKick,
  getCoopBuildings: coops.getCoopBuildings,
  upgradeCoopBuilding: coops.upgradeCoopBuilding,
  getCoopStorage: coops.getCoopStorage,
  depositCoop: coops.depositCoop,
  doChore: coops.doChore,
  getCoopShop: coops.getCoopShop,
  buyCoopShop: coops.buyCoopShop,
  getCoopBoard: coops.getCoopBoard,
  callCoopBoss: coops.callCoopBoss,
  getBossInstance: coops.getBossInstance,
  getInstanceResult: coops.getInstanceResult,
  ackInstanceResult: coops.ackInstanceResult,
  getCoopBossCalls: coops.getCoopBossCalls,
  getInstanceContributions: coops.getInstanceContributions,
  // §6 карта и бой
  getDistricts: battles.getDistricts,
  startBattle: battles.startBattle,
  getActiveBattle: battles.getActiveBattle,
  battleTurn: battles.battleTurn,
  battleRetreat: battles.battleRetreat,
  getBattle: battles.getBattle,
  getBattles: battles.getBattles,
  // §12 магазин
  getShop: shop.getShop,
  getLimitedSet: shop.getLimitedSet,
  createOrder: shop.createOrder,
  getPurchases: shop.getPurchases,
  ackRefundNotice: shop.ackRefundNotice,
  buyForTalons: shop.buyForTalons,
  getShowcase: shop.getShowcase,
  buyShowcase: shop.buyShowcase,
  getOrder: shop.getOrder,
  cancelOrder: shop.cancelOrder,
  // §17–§18 служебные
  healthLive: system.healthLive,
  healthReady: system.healthReady,
  getMeta: system.getMeta,
  clientErrors: system.clientErrors,
  getSync: system.getSync,
} as const;

export type Api = typeof api;
export type EndpointName = keyof Api;
